export default "__VITE_ASSET__DF5FWL_R__"